import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { LoginPage } from "./routes/login";
import { EsqueciSenhaPage } from "./routes/esqueci-senha";
import { PrimeiroAcessoPage } from "./routes/primeiro-acesso";
import { ServidorDashboard } from "./routes/servidor/dashboard";
import { ServidorLayout } from "./routes/servidor/layout";
import { ServidorSelecionarMatricula } from "./routes/servidor/selecionar-matricula";
import { ServidorPortabilidade } from "./routes/servidor/portabilidade";
import { ServidorRefinanciamento } from "./routes/servidor/refinanciamento";
import { ServidorSolicitarCartao } from "./routes/servidor/solicitar-cartao";
import { ServidorTermo } from "./routes/servidor/termo";
import { ServidorMarketplace } from "./routes/servidor/marketplace";
import { ServidorMarketplacePortabilidade } from "./routes/servidor/marketplace-portabilidade";
import { ServidorMinhaMargem } from "./routes/servidor/minha-margem";
import { ServidorSimular } from "./routes/servidor/simular";
// Rota /servidor/propostas foi removida — propostas agora aparecem embutidas
// em /servidor/contratos (secao "Em andamento" + Historico).
// import { ServidorPropostas } from "./routes/servidor/propostas";
import { ServidorContratos } from "./routes/servidor/contratos";
import { ServidorConta } from "./routes/servidor/conta";
import { ServidorBeneficios } from "./routes/servidor/beneficios";
import { ServidorMeusBeneficios } from "./routes/servidor/meus-beneficios";
import { AverbadoraLayout } from "./routes/averbadora/layout";
import { AverbadoraDashboard } from "./routes/averbadora/dashboard";
import { AdminBancos } from "./routes/averbadora/bancos";
import { AdminOrganizacoes } from "./routes/averbadora/organizacoes";
import { AdminOrganizacaoFicha } from "./routes/averbadora/organizacao-ficha";
import { AdminRelacoes } from "./routes/averbadora/relacoes";
import { AdminConvenios } from "./routes/averbadora/convenios";
import { AdminContratos } from "./routes/averbadora/contratos";
import { AdminServidoresLanding } from "./routes/averbadora/servidores/index";
import { AdminServidoresVisualizar } from "./routes/averbadora/servidores/visualizar";
import { AdminServidoresImportar } from "./routes/averbadora/servidores/importar";
import { AdminFolhas } from "./routes/averbadora/folhas";
import { AdminTrocaArquivos } from "./routes/averbadora/troca-arquivos";
import { AdminLayoutsHub } from "./routes/averbadora/layouts";
import { AdminConsignatariasArquivos } from "./routes/averbadora/consignatarias-arquivos";
import { AdminSolicitacoesCancelamento } from "./routes/averbadora/solicitacoes-cancelamento";
import { AdminLayoutsEnsaio } from "./routes/averbadora/layouts-ensaio";
import { AdminLayoutsFicha } from "./routes/averbadora/layouts-ficha";
import { AdminLayoutsUnidade } from "./routes/averbadora/layouts-unidade";
import { AdminMotorRubricas } from "./routes/averbadora/motor-rubricas";
import { AdminComunicados } from "./routes/averbadora/comunicados";
import { AdminHealth } from "./routes/averbadora/health";
import { AverbadoraVerify } from "./routes/averbadora/verify";
import { AverbadoraConfiguracoes } from "./routes/averbadora/configuracoes";
import { AdminLogs } from "./routes/averbadora/logs";
import { AdminVitrine } from "./routes/averbadora/vitrine";
import { AdminBeneficios } from "./routes/averbadora/beneficios";
import { AdminBeneficiosForm } from "./routes/averbadora/beneficios-form";
import { AdminEmails } from "./routes/averbadora/emails";
import { AverbadoraTelemedicina } from "./routes/averbadora/telemedicina";
import { AverbadoraTelemedicinaCotacao } from "./routes/averbadora/telemedicina-cotacao";
import { AverbadoraInteressados } from "./routes/averbadora/interessados";
import { AverbadoraApiDocs } from "./routes/averbadora/api/docs";
import { AverbadoraApiTokens } from "./routes/averbadora/api/tokens";
import { AverbadoraApiUso } from "./routes/averbadora/api/uso";
import { AverbadoraApiWebhooks } from "./routes/averbadora/api/webhooks";
import { AdminPreReservas } from "./routes/averbadora/pre-reservas";
import { AdminIdUnico } from "./routes/averbadora/id-unico";
import { AdminBateCarteira } from "./routes/averbadora/bate-carteira";
import { AdminRubricas } from "./routes/averbadora/rubricas";
import { AverbadoraTravaMargem } from "./routes/averbadora/trava-margem";
import { AdminAdf } from "./routes/averbadora/adf";
import { AverbadoraPortabilidade } from "./routes/averbadora/portabilidade";
import { AverbadoraRefinanciamentos } from "./routes/averbadora/refinanciamentos";
import { AverbadoraTermos } from "./routes/averbadora/termos";
import { AverbadoraSuporte } from "./routes/averbadora/suporte";
import { AdminAuditoria } from "./routes/averbadora/auditoria";
import { AdminPerfis } from "./routes/averbadora/perfis";
import { AverbadoraConta } from "./routes/averbadora/conta";
import { PrefeituraLayout } from "./routes/prefeitura/layout";
import { PrefeituraDashboard } from "./routes/prefeitura/dashboard";
import { PrefeituraServidores } from "./routes/prefeitura/servidores";
import { PrefeituraContratos } from "./routes/prefeitura/contratos";
import { PrefeituraConvenios } from "./routes/prefeitura/convenios";
import { PrefeituraTrocaArquivos } from "./routes/prefeitura/troca-arquivos";
import { PrefeituraAdf } from "./routes/prefeitura/adf";
import { PrefeituraRelatorios } from "./routes/prefeitura/relatorios";
import { PrefeituraRepasses } from "./routes/prefeitura/repasses";
import { PrefeituraAnuencia } from "./routes/prefeitura/anuencia";
import { PrefeituraPerfis } from "./routes/prefeitura/perfis";
import { PrefeituraComunicados } from "./routes/prefeitura/comunicados";
import { PrefeituraMateriais } from "./routes/prefeitura/materiais";
import { BancoLayout } from "./routes/banco/layout";
import { BancoConta } from "./routes/banco/conta";
import { PrefeituraConta } from "./routes/prefeitura/conta";
import { BancoVisaoGeral } from "./routes/banco/visao-geral";
import { BancoVisaoDoMes } from "./routes/banco/visao-do-mes";
import { BancoBeneficios } from "./routes/banco/beneficios";
import { BancoBeneficioDetalhe } from "./routes/banco/beneficios/detalhe";
import { BancoPedidosCancelamento } from "./routes/banco/pedidos-cancelamento";
import { BancoInicio } from "./routes/banco/inicio";
import { BancoPropostas } from "./routes/banco/propostas/index";
import { BancoPropostaDetalhe } from "./routes/banco/propostas/detalhe";
import { BancoOfertas } from "./routes/banco/ofertas";
import { BancoCarteira } from "./routes/banco/carteira/index";
import { BancoRefinanciamentos } from "./routes/banco/refinanciamentos";
import { BancoBateCarteira } from "./routes/banco/bate-carteira";
import { BancoTrocaArquivos } from "./routes/banco/troca-arquivos";
import { BancoConvenios } from "./routes/banco/convenios";
import { BancoRegrasConvenio } from "./routes/banco/regras-convenio-pagina";
import { BancoApi } from "./routes/banco/api";
import { BancoMargemContratacaoBusca } from "./routes/banco/margem-contratacao/index";
import { BancoMargemContratacaoFicha } from "./routes/banco/margem-contratacao/ficha";
import { OperacaoForm } from "./routes/banco/margem-contratacao/OperacaoForm";
import { BancoTabelaEmprestimosLista } from "./routes/banco/cadastros/tabela-emprestimos/index";
import { BancoTabelaEmprestimosForm } from "./routes/banco/cadastros/tabela-emprestimos/form";
import { BancoSubOrganizacoesLista } from "./routes/banco/cadastros/sub-organizacoes/index";
import { BancoSubOrganizacoesForm } from "./routes/banco/cadastros/sub-organizacoes/form";
import { BancoUsuariosLista } from "./routes/banco/cadastros/usuarios/index";
import { BancoUsuariosForm } from "./routes/banco/cadastros/usuarios/form";
import { BancoTrocarSenha } from "./routes/banco/trocar-senha";
import { BancoPortabilidade } from "./routes/banco/portabilidade";
import { PrefeituraTrocarSenha } from "./routes/prefeitura/trocar-senha";
import { BancoRelatorioConsignacoes } from "./routes/banco/relatorios/consignacoes";
import { BancoRelatorioGerador } from "./routes/banco/relatorios/gerador";
import { BancoRelatorioFaturamento } from "./routes/banco/relatorios/faturamento";
import { readStoredRole } from "./lib/sdk";

type Tipo = "EMPRESTIMO" | "REFIN" | "COMPOSTA";
function OperacaoRoute({ modo, tipoFromParam }: { modo: "averbar" | "reservar"; tipoFromParam: boolean }) {
  if (tipoFromParam) {
    const path = window.location.pathname;
    const last = path.split("/").pop()?.toUpperCase() ?? "EMPRESTIMO";
    const tipo = (
      ["EMPRESTIMO", "REFIN", "COMPOSTA"].includes(last) ? last : "EMPRESTIMO"
    ) as Tipo;
    return <OperacaoForm modo={modo} tipo={tipo} />;
  }
  return <OperacaoForm modo={modo} tipo="EMPRESTIMO" />;
}

function RequireAuth({ role }: { role: "servidor" | "banco" | "averbadora" | "prefeitura" }) {
  const stored = readStoredRole();
  if (!stored) return <Navigate to="/login" replace />;
  if (stored !== role) return <Navigate to={`/${stored}/dashboard`} replace />;
  return <Outlet />;
}

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  { path: "/", element: <Navigate to="/login" replace /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/esqueci-senha", element: <EsqueciSenhaPage /> },
  { path: "/primeiro-acesso", element: <PrimeiroAcessoPage /> },

  // Servidor (marketplace completo)
  {
    path: "/servidor",
    element: <RequireAuth role="servidor" />,
    children: [
      // Standalone fullscreen page (no ServidorLayout): matricula selector.
      { path: "selecionar-matricula", element: <ServidorSelecionarMatricula /> },
      {
        element: <ServidorLayout />,
        children: [
          { index: true, element: <Navigate to="dashboard" replace /> },
          { path: "dashboard", element: <ServidorDashboard /> },
          { path: "marketplace", element: <ServidorMarketplace /> },
          { path: "marketplace/portabilidade", element: <ServidorMarketplacePortabilidade /> },
          { path: "minha-margem", element: <ServidorMinhaMargem /> },
          { path: "simular", element: <ServidorSimular /> },
          { path: "portabilidade", element: <ServidorPortabilidade /> },
          { path: "refinanciamento", element: <ServidorRefinanciamento /> },
          { path: "solicitar-cartao", element: <ServidorSolicitarCartao /> },
          { path: "termo", element: <ServidorTermo /> },
          // Rota /servidor/propostas removida — foi fundida em /servidor/contratos.
          { path: "contratos", element: <ServidorContratos /> },
          { path: "beneficios", element: <ServidorBeneficios /> },
          { path: "meus-beneficios", element: <ServidorMeusBeneficios /> },
          { path: "conta", element: <ServidorConta /> },
        ],
      },
    ],
  },

  // Banco (UX Consignet com design Atlas)
  {
    path: "/banco",
    element: <RequireAuth role="banco" />,
    children: [
      {
        element: <BancoLayout />,
        children: [
          // #314: a entrada depende do modo do credor (Visao do mes para quem
          // opera beneficios) — `BancoInicio` decide pelo `me`.
          { index: true, element: <BancoInicio /> },
          { path: "dashboard", element: <Navigate to="../visao-geral" replace /> },
          { path: "visao-geral", element: <BancoVisaoGeral /> },
          { path: "visao-do-mes", element: <BancoVisaoDoMes /> },
          { path: "beneficios", element: <BancoBeneficios /> },
          { path: "beneficios/:id", element: <BancoBeneficioDetalhe /> },
          { path: "pedidos-cancelamento", element: <BancoPedidosCancelamento /> },

          { path: "propostas", element: <BancoPropostas /> },
          { path: "portabilidade", element: <BancoPortabilidade /> },
          { path: "propostas/:id", element: <BancoPropostaDetalhe /> },
          { path: "ofertas", element: <BancoOfertas /> },

          { path: "carteira", element: <BancoCarteira /> },
          { path: "refinanciamentos", element: <BancoRefinanciamentos /> },
          { path: "bate-carteira", element: <BancoBateCarteira /> },
          { path: "troca-arquivos", element: <BancoTrocaArquivos /> },
          { path: "convenios", element: <BancoConvenios /> },
          { path: "convenios/regras", element: <BancoRegrasConvenio /> },

          { path: "cadastros/tabela-emprestimos", element: <BancoTabelaEmprestimosLista /> },
          { path: "cadastros/tabela-emprestimos/novo", element: <BancoTabelaEmprestimosForm /> },
          { path: "cadastros/tabela-emprestimos/:id", element: <BancoTabelaEmprestimosForm /> },
          { path: "cadastros/sub-organizacoes", element: <BancoSubOrganizacoesLista /> },
          { path: "cadastros/sub-organizacoes/novo", element: <BancoSubOrganizacoesForm /> },
          { path: "cadastros/sub-organizacoes/:id", element: <BancoSubOrganizacoesForm /> },
          { path: "cadastros/usuarios", element: <BancoUsuariosLista /> },
          { path: "cadastros/usuarios/novo", element: <BancoUsuariosForm /> },
          { path: "cadastros/usuarios/:id", element: <BancoUsuariosForm /> },

          { path: "margem-contratacao", element: <BancoMargemContratacaoBusca /> },
          { path: "margem-contratacao/:idMatricula", element: <BancoMargemContratacaoFicha /> },
          {
            path: "margem-contratacao/:idMatricula/averbar/:tipo",
            element: <OperacaoRoute modo="averbar" tipoFromParam />,
          },
          {
            path: "margem-contratacao/:idMatricula/reservar/:tipo",
            element: <OperacaoRoute modo="reservar" tipoFromParam />,
          },

          { path: "relatorios/consignacoes", element: <BancoRelatorioConsignacoes /> },
          { path: "relatorios/gerador", element: <BancoRelatorioGerador /> },
          { path: "relatorios/faturamento", element: <BancoRelatorioFaturamento /> },
          // `:slug` e a pagina da documentacao (guias, erros, referencia). Sem
          // slug abre a primeira — o link direto pra uma pagina precisa existir.
          { path: "api", element: <BancoApi /> },
          { path: "api/:slug", element: <BancoApi /> },
          { path: "conta", element: <BancoConta /> },
        ],
      },
      // Troca obrigatoria da senha temporaria. Dentro do RequireAuth (exige
      // sessao de banco) e FORA do BancoLayout, de proposito: com a senha ainda
      // temporaria a API recusa toda rota de recurso com 403, entao o layout
      // montaria a casca inteira so' para que nada dentro dela carregue. A tela
      // tem chrome proprio, como o login.
      { path: "trocar-senha", element: <BancoTrocarSenha /> },
    ],
  },

  // Averbadora (super-admin)
  {
    path: "/averbadora",
    element: <RequireAuth role="averbadora" />,
    children: [
      {
        element: <AverbadoraLayout />,
        children: [
          { index: true, element: <Navigate to="dashboard" replace /> },
          { path: "dashboard", element: <AverbadoraDashboard /> },
          { path: "bancos", element: <AdminBancos /> },
          // Feature 009: a tela cadastra órgãos e entidades de todo tipo, e a
          // rota nova é a que o menu aponta. A antiga vira redirect por uma
          // release, porque está em favorito e em link de e-mail. Renomear o
          // CAMINHO DA API é outra coisa, e é da fase E.
          { path: "organizacoes", element: <AdminOrganizacoes /> },
          { path: "organizacoes/:id", element: <AdminOrganizacaoFicha /> },
          { path: "prefeituras", element: <Navigate to="/averbadora/organizacoes" replace /> },
          // A tela de relações é irmã da de órgãos, e não uma sub-rota dela: a
          // relação tem DUAS pontas, e pendurá-la sob uma organização faria a
          // tela ter de escolher qual das duas é a dona.
          { path: "relacoes", element: <AdminRelacoes /> },
          { path: "convenios", element: <AdminConvenios /> },
          { path: "contratos", element: <AdminContratos /> },
          { path: "servidores", element: <AdminServidoresLanding /> },
          { path: "servidores/visualizar", element: <AdminServidoresVisualizar /> },
          { path: "servidores/importar", element: <AdminServidoresImportar /> },
          { path: "folhas", element: <AdminFolhas /> },
          { path: "troca-arquivos", element: <AdminTrocaArquivos /> },
          // Layouts (feature 008): o hub e' a pagina do item de menu; as
          // sub-rotas literais (`ensaio`, `unidade/:id`) vem ANTES de `:codigo`,
          // senao a ficha capturaria "ensaio" como codigo de layout. `activeKey`
          // continua "layouts" em todas — o menu tem UM item.
          { path: "consignatarias/arquivos", element: <AdminConsignatariasArquivos /> },
          { path: "solicitacoes-cancelamento", element: <AdminSolicitacoesCancelamento /> },
          { path: "layouts", element: <AdminLayoutsHub /> },
          { path: "layouts/ensaio", element: <AdminLayoutsEnsaio /> },
          { path: "layouts/unidade/:id", element: <AdminLayoutsUnidade /> },
          { path: "layouts/:codigo", element: <AdminLayoutsFicha /> },
          { path: "pre-reservas", element: <AdminPreReservas /> },
          { path: "id-unico", element: <AdminIdUnico /> },
          { path: "bate-carteira", element: <AdminBateCarteira /> },
          { path: "rubricas", element: <AdminMotorRubricas /> },
          { path: "trava-margem", element: <AverbadoraTravaMargem /> },
          // A importacao do relatorio de conciliacao fica em sub-rota: e um fluxo
          // de duas etapas (mapear folha do relatorio -> folha da Atlas, depois
          // aplicar) e empilha-la no catalogo reproduziria a mistura que a tela
          // nova desfez. `activeKey` continua `rubricas`, entao o grant tambem.
          { path: "rubricas/conciliacao", element: <AdminRubricas /> },
          { path: "adf", element: <AdminAdf /> },
          { path: "portabilidade", element: <AverbadoraPortabilidade /> },
          { path: "refinanciamentos", element: <AverbadoraRefinanciamentos /> },
          { path: "termos", element: <AverbadoraTermos /> },
          { path: "auditoria", element: <AdminAuditoria /> },
          { path: "perfis", element: <AdminPerfis /> },
          { path: "comunicados", element: <Navigate to="/averbadora/comunicados/banco" replace /> },
          { path: "comunicados/banco", element: <AdminComunicados publico="banco" /> },
          { path: "comunicados/servidor", element: <AdminComunicados publico="servidor" /> },
          { path: "comunicados/prefeitura", element: <AdminComunicados publico="prefeitura" /> },
          { path: "health", element: <AdminHealth /> },
          { path: "verify", element: <AverbadoraVerify /> },
          { path: "configuracoes", element: <AverbadoraConfiguracoes /> },
          { path: "suporte", element: <AverbadoraSuporte /> },
          { path: "ia", element: <AverbadoraConfiguracoes /> },
          { path: "logs", element: <AdminLogs /> },
          { path: "vitrine", element: <AdminVitrine /> },
          { path: "beneficios", element: <AdminBeneficios /> },
          { path: "beneficios/novo", element: <AdminBeneficiosForm /> },
          { path: "beneficios/:id/editar", element: <AdminBeneficiosForm /> },
          // E-mails do sistema: 5 sub-rotas, cada uma passa o evento correspondente.
          { path: "emails", element: <Navigate to="/averbadora/emails/primeiro-acesso" replace /> },
          { path: "emails/primeiro-acesso", element: <AdminEmails evento="primeiro_acesso" /> },
          { path: "emails/recuperar-senha", element: <AdminEmails evento="recuperar_senha" /> },
          { path: "emails/redefinir-senha", element: <AdminEmails evento="redefinir_senha" /> },
          { path: "emails/simulacao", element: <AdminEmails evento="simulacao" /> },
          { path: "emails/beneficios", element: <AdminEmails evento="beneficio" /> },
          { path: "emails/pedidos-cancelamento", element: <AdminEmails evento="solicitacao_cancelamento" /> },
          { path: "emails/arquivo-pendente", element: <AdminEmails evento="arquivo_pendente" /> },
          { path: "telemedicina", element: <AverbadoraTelemedicina /> },
          { path: "telemedicina/:id", element: <AverbadoraTelemedicinaCotacao /> },
          { path: "interessados", element: <AverbadoraInteressados /> },
          { path: "api/docs", element: <AverbadoraApiDocs /> },
          { path: "api/docs/:slug", element: <AverbadoraApiDocs /> },
          { path: "api/tokens", element: <AverbadoraApiTokens /> },
          { path: "api/uso", element: <AverbadoraApiUso /> },
          { path: "api/webhooks", element: <AverbadoraApiWebhooks /> },
          { path: "conta", element: <AverbadoraConta /> },
        ],
      },
    ],
  },

  // Prefeitura (portal read-only)
  {
    path: "/prefeitura",
    element: <RequireAuth role="prefeitura" />,
    children: [
      {
        element: <PrefeituraLayout />,
        children: [
          { index: true, element: <Navigate to="dashboard" replace /> },
          { path: "dashboard", element: <PrefeituraDashboard /> },
          { path: "servidores", element: <PrefeituraServidores /> },
          { path: "contratos", element: <PrefeituraContratos /> },
          { path: "convenios", element: <PrefeituraConvenios /> },
          // /prefeitura/folhas VIROU REDIRECT.
          //
          // A tela era um CRUD de folha mais tres botoes que levavam para Troca de
          // arquivos, e o estado da competencia (corte, movimento, retorno, repasse)
          // agora vive na aba Competencias de lá — junto do que se FAZ com ele.
          //
          // Redirect e nao remocao: o link esta em favoritos, em email, e no
          // historico do navegador de quem usa o sistema. Um 404 seria uma falha
          // sem informacao; o redirect leva ao lugar certo.
          { path: "folhas", element: <Navigate to="/prefeitura/troca-arquivos?aba=competencias" replace /> },
          { path: "troca-arquivos", element: <PrefeituraTrocaArquivos /> },
          { path: "adf", element: <PrefeituraAdf /> },
          { path: "relatorios", element: <PrefeituraRelatorios /> },
          { path: "repasses", element: <PrefeituraRepasses /> },
          { path: "anuencia", element: <PrefeituraAnuencia /> },
          { path: "perfis", element: <PrefeituraPerfis /> },
          { path: "comunicados", element: <PrefeituraComunicados /> },
          { path: "materiais", element: <PrefeituraMateriais /> },
          { path: "conta", element: <PrefeituraConta /> },
        ],
      },
      // Troca obrigatoria da senha temporaria. Dentro do RequireAuth (exige
      // sessao de prefeitura) e FORA do PrefeituraLayout, de proposito: com a
      // senha ainda temporaria a API recusa toda rota do portal com 403, entao o
      // layout montaria a casca inteira so' para que nada dentro dela carregue.
      // A tela tem chrome proprio, como o login.
      { path: "trocar-senha", element: <PrefeituraTrocarSenha /> },
    ],
  },
]);
